export default {
  SET_EMAILS_LIST(state, {
    pages,
    itemPerPages,
    emails = []
  }) {
    state.emails = emails;
    state.pages = pages;
    state.itemPerPages = itemPerPages;
  },
  SET_EMAILS_SUPPRESSION_LIST(state, {
    pages,
    itemPerPages,
    list = []
  }) {
    state.suppressions = list;
    state.suppressionsPages = pages;
    state.suppressionsItemPerPages = itemPerPages;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_LOADING_SUPPRESSION(state, loading) {
    state.loadingSuppression = loading;
  },
  SET_LOADING_EVENTOS(state, loading) {
    state.loadingEventos = loading;
  },
  SET_EMAIL(state, { email }) {
    state.email = email;
  },
  SET_EVENTOS(state, { eventos }) {
    state.eventos = eventos;
  },
  CLEAR_EVENTOS(state) {
    state.eventos = [];
  },
  SET_FILTERS(state, { ...filters }) {
    state.filters = filters;
  },
  SET_PAGE(state, { page }) {
    state.page = page;
  },
  SET_ITEM_PER_PAGE(state, { items, page }) {
    state.itemsPerPage = items;
    state.page = page;
  },
  SET_PAGE_SUPPRESSION(state, { page }) {
    state.suppressionsPage = page;
  },
  SET_ITEM_PER_PAGE_SUPPRESSION(state, { items, page }) {
    state.suppressionsItemsPerPage = items;
    state.suppressionsPage = page;
  },
};
